var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoldenLockIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8686 7.26795C11.8686 6.55371 11.2543 5.97286 10.4988 5.97286H9.81393V4.03022C9.81393 2.24493 8.27769 0.79248 6.3894 0.79248C4.50112 0.79248 2.96487 2.24493 2.96487 4.03022V5.97286H2.27997C1.52452 5.97286 0.910156 6.55371 0.910156 7.26795V12.4483C0.910156 13.1626 1.52452 13.7434 2.27997 13.7434H10.4988C11.2543 13.7434 11.8686 13.1626 11.8686 12.4483V7.26795ZM4.33468 4.03022C4.33468 2.95917 5.25657 2.08757 6.3894 2.08757C7.52224 2.08757 8.44412 2.95917 8.44412 4.03022V5.97286H4.33468V4.03022Z",
    fill: "#E6C556"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldenLockIcon);
export default __webpack_public_path__ + "static/media/GoldenLockIcon.d565492ed03f2a6c1b3957dc2e7822d9.svg";
export { ForwardRef as ReactComponent };